import React from 'react';
import PropTypes from 'prop-types';
import '../style.scss';

/**
 * Wrapper :
 * - Wrapper for HexagonCard
 */
export function Wrapper(props) {
  const className = `hex ${props.className}`;
  return (
    <div className={className} tabIndex={props.tabIndex}>
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
  /**
   * Child components
   */
  children: PropTypes.array,
};

Wrapper.defaultProps = {
  className: '',
};
